import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DataService} from "../../services/data.service";
import {Story} from "../../interfaces/story";
import {EffectCoverflow, Keyboard, Swiper, SwiperOptions, Virtual} from "swiper";
import {UtilsService} from "../../services/utils.service";
import {Overlayable} from "../../interfaces/overlayable";
import {OverlayService} from "../../overlay/overlay.service";
import {ItemActionElement} from "../../atoms/item-actions/item-action-element";
import {Router} from "@angular/router";
import {StoryShareOverlayComponent} from "../../shared/story-share-overlay/story-share-overlay.component";
import {StoryService} from "../story.service";
import {UrlHashService} from "../../services/url-hash.service";
import {DisplayService} from "../../services/display.service";
import {ProfessionsService} from "../../services/professions.service";
import {JobService} from "../../services/job.service";
import {InsightsOverviewService} from "../../insights/insights-overview/insights-overview.service";
import {ProvidersService} from "../../services/providers.service";
import {ProviderTypes} from "../../enums/provider-types";
import {TrophyEndpointService} from "../../services/trophy-endpoint.service";
import {TrophyItemType} from "../../enums/trophy-item-type";
import {StoryCardLayout} from "../card/story-card-layout";
import {StudentAuthService} from "../../services/student-auth.service";

Swiper.use([EffectCoverflow, Keyboard, Virtual]);

@Component({
  selector: 'brt-story',
  templateUrl: './story.component.html',
  styleUrls: ['./story.component.scss']
})
export class StoryComponent implements OnInit, AfterViewInit, Overlayable {

  @ViewChild('dialogEl') dialogEl!: any;
  @Input("story") set setStory(value: Story) {

    this.storyData = value;

    // Remove QUIZ Card because doesn't exist anymore
    this.storyData.cards = this.storyData.cards.filter((el) => el.layout !== StoryCardLayout.QUIZ);

    // Remove QUIZGAME if not logged in
    if(!this.studentAuthService.isLoggedIn()) {
      this.storyData.cards = this.storyData.cards.filter((el) => el.layout !== StoryCardLayout.QUIZGAME);
    }

    this.trophySet = false;
    this.totalCardNumber = this.utils.getNumberWithLeadingZero(value.cards.length + 1);
    // console.log(this.storyData);
  }

  @Input('initialSlide') set setInitialSlide(val: number) {
    if(val < 0) val = 0;
    if(this.storyData) {
      if(val > this.storyData.cards.length) val = 0;
    }

    this.initialSlide = val;
    if(this.slider) {
      this.slider.slideTo(val);
    }
  }


  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  storyData!: Story;

  progress = 0;

  constructor(
    private data: DataService,
    private utils: UtilsService,
    private overlayService: OverlayService,
    private router: Router,
    private storyService: StoryService,
    private urlHashService: UrlHashService,
    private display: DisplayService,
    private professionsService: ProfessionsService,
    private jobsService: JobService,
    private providersService: ProvidersService,
    private insightsOverviewService: InsightsOverviewService,
    private trophyEndpointService: TrophyEndpointService,
    private studentAuthService: StudentAuthService,
  ) {}

  currentSlideIdx = 0;
  currentCardNumber = '01';
  totalCardNumber = '00';
  initialSlide = 1;
  isFirstSlide = true;
  isLastSlide = false;

  slider!: Swiper;

  trophySet = false;

  sliderOptionsDesktop: SwiperOptions = {
    centeredSlides: true,
    spaceBetween: 0,
    threshold: 5,
    initialSlide: this.initialSlide - 1,
    keyboard: {
      enabled: true,
      onlyInViewport: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: "auto",
        spaceBetween: 0,
        allowTouchMove: false
      }
    },
    on: {
      slideChangeTransitionStart: (swiper: Swiper) => { // some workaround for scales and transforms for slides that are far from center
        swiper.slides.forEach((slide, idx) => {
          slide.classList.remove("before-slide");
          slide.classList.remove("after-slide");
          // console.log(idx, this.currentSlideIdx);
          if(idx < this.currentSlideIdx - 2) slide.classList.add("before-slide");
          else if(idx > this.currentSlideIdx + 2) slide.classList.add("after-slide");
        })
      }
    }
  }
  sliderOptionsMobile: SwiperOptions = {
    ...this.sliderOptionsDesktop,
    touchStartForcePreventDefault: true,
    virtual: {
      enabled: true
    }
  }

  sliderOptions = this.display.isMobileScreenSize() ? this.sliderOptionsMobile : this.sliderOptionsDesktop

  mobileActionsMenu: ItemActionElement[] = [];

  ngOnInit() {

    // Graphql ID for dummy story: 2695

    // console.log("NG ON INIT STORY");
    // this.data.getStoryById("dummy-story").subscribe(response => {
    //   this.storyData = response;
    //   this.totalCardNumber = this.utils.getNumberWithLeadingZero(this.storyData.cards.length);
    //   this.initialSlide = this.storyData.cards.length - 4;
    //   this.currentCardNumber = this.utils.getNumberWithLeadingZero(this.initialSlide);
    // })
    this.mobileActionsMenu = this.generateActionMenu();
  }


  ngAfterViewInit() {
    console.warn("ngAfterViewInit")
    this.dialogEl?.nativeElement?.showModal();
  }


  goToSlide(idx: number) {
    if(this.slider) {
      if(idx < this.slider.activeIndex) this.slider.slidePrev();
      else if(idx > this.slider.activeIndex) this.slider.slideNext();
    }
  }

  sliderInit(slider: [swiper: Swiper]) {
    this.slider = slider[0];

    if(this.initialSlide === 1) {
      this.urlHashService.updateHash(this.storyService.getStoryHashLink(this.storyData.id ?? -1, 1));
      this.showTutorial();

    }
    this.slider.slideTo(this.initialSlide - 1, 0);
  }

  showTutorial() {
    if(this.slider) {
      const tutorialPlayed = window.localStorage.getItem("story-tutorial");
      // console.log(tutorialPlayed);
      if(!tutorialPlayed) {
        this.slider.$el.addClass("show-pulse-anim");
        window.localStorage.setItem("story-tutorial", '1');

        setTimeout(() => {
          this.slider.$el.removeClass("show-pulse-anim");
        }, 4000);
      }

    }

  }

  onSlideChanged(slider: [swiper: Swiper]) {
    this.currentCardNumber = this.utils.getNumberWithLeadingZero(slider[0].activeIndex + 1);
    this.progress = slider[0].progress;
    this.currentSlideIdx = slider[0].activeIndex;
    this.urlHashService.updateHash(this.storyService.getStoryHashLink(this.storyData.id ?? -1, this.currentSlideIdx + 1));
    this.isFirstSlide = this.currentSlideIdx === 0;
    this.isLastSlide = slider[0].isEnd;

    if(this.currentSlideIdx > Math.round(this.storyData.cards.length / 2) && !this.trophySet) {
      this.trophySet = true;
      if(this.storyData.portrait === "Schulportrait") {
        this.trophyEndpointService.setTrophy(this.storyData.id.toString(), TrophyItemType.SCHOOLPORTRAIT);
      } else {
        this.trophyEndpointService.setTrophy(this.storyData.id.toString(), TrophyItemType.JOBPORTRAIT);
      }
    }

  }

  goToPrevSlide() {
    this.slider.slidePrev()
  }

  goToNextSlide() {
    // console.log("SLIDE NEXT");
    this.slider.slideNext()
  }

  onShareButtonClicked() {
    const currentSlideNumber = this.slider.activeIndex;
    console.log('current-slider-number', currentSlideNumber);
    this.overlayService.openWindowOverlay({
      title: "Teilen",
      componentMain: {
        component: StoryShareOverlayComponent,
        data: {
          data: {
            storyId: this.storyData?.id, cardIndex: this.currentSlideIdx + 1, totalCards: parseInt(this.totalCardNumber)
          }
        }
      }
    });
  }

  generateActionMenu(): ItemActionElement[] {


    const items: ItemActionElement[] = [
      {
        icon: "",
        title: `Alle ${this.storyData.portrait}s`,
        isActive: true,
        func: () => {
          this.onClosed.emit(true);
          this.insightsOverviewService.setInsightsFilter(this.storyData.portrait, 1);
        }
      }
    ]

    if(this.storyData.portrait === "Schulportrait") {
      items.push({
        icon: "",
        title: "Zu der weiterführenden Schule",
        isActive: true,
        func: () => {
          this.onClosed.emit(true);
          if(this.storyData.schoolProfileUuid.length) {
            this.router.navigateByUrl(this.providersService.getProviderDetailPageUrlById(this.storyData.schoolProfileUuid, ProviderTypes.SCHOOL));
          }
        }
      });
    } else {
      items.push({
          icon: "",
          title: "Zum Berufsbild",
          isActive: true,
          func: () => {
            this.onClosed.emit(true);
            if(this.storyData.bicId > 0) {
              this.router.navigateByUrl(this.professionsService.getProfessionUrlById(this.storyData.bicId));
            }
          }
        },
        {
          icon: "",
          title: "Zu den Ausbildungsbetrieben",
          isActive: true,
          func: () => {
            this.router.navigateByUrl('/' + this.providersService.getFilterUrl(1, [], [], [], "", [], "", 0, "", false, false, this.storyData.bicId, {lat: 0, lng: 0}));
            this.onClosed.emit(true);
          }
        },
        {
          icon: "",
          title: "Zu den Jobangeboten",
          isActive: true,
          func: () => {
            this.router.navigateByUrl('/' + this.jobsService.getFilterUrl(1, [], [], "", [], "", 0, "", false, false, this.storyData.bicId,  {lat: 0, lng: 0}));
            this.onClosed.emit(true);
          }
        });
    }

    items.push(
      {
        icon: "share",
        title: "Teilen",
        isActive: true,
        func: () => {
          this.onShareButtonClicked();
        }
      }
    );

    return items;
  }

  closeStory() {
    this.urlHashService.updateHash("");
    this.onClosed.emit(true);
  }
}
